
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-language-switcher',
    templateUrl: './language-switcher.component.html',
    styleUrl: './language-switcher.component.scss',
    imports: [
    MatFormFieldModule,
    FormsModule,
    MatSelectModule,
    MatIconModule
]
})
export class LanguageSwitcherComponent {
  languages = [
    { code: 'fr', name: 'Français' },
    { code: 'en', name: 'English' },
    { code: 'es', name: 'Español' }
  ];

  private readonly LANGUAGE_STORAGE_KEY = 'app-language';

  constructor(
    private dateAdapter: DateAdapter<any>,
    public translateService: TranslateService
  ) {
    this.initializeLanguage();
  }

  private initializeLanguage(): void {
    const savedLanguage = localStorage.getItem(this.LANGUAGE_STORAGE_KEY);
    if (savedLanguage) {
      this.translateService.use(savedLanguage);
      this.dateAdapter.setLocale(savedLanguage);
    }
  }

  switchLanguage(event: Event) {
    const selectedLang = (event.target as HTMLSelectElement).value;
    this.translateService.use(selectedLang);
    this.dateAdapter.setLocale(selectedLang);
    localStorage.setItem(this.LANGUAGE_STORAGE_KEY, selectedLang);
  }

}
